// import React from 'react'
import * as yup from 'yup'
import { multilineField } from '../../../../fields/complaint'
import { Divider } from '../../../../components/divider'
import { convertHashToChoiceArray } from '../../../../choices/convertHashToChoiceArray'
import { races } from 'hotline_complaint_choices'
import { WeightField } from '../../../../components/WeightField/WeightField'
import { HeightField } from '../../../../components/HeightField/HeightField'
import { stringYupOptional } from '../../../../validators'
import { maxLength2000Message } from '../../../../strings/messages'

export const fugitiveDescription = {
  id: 'fugitive_description',
  title: 'Describe the fugitive',
  validation: yup.object().shape({
    additional_information: stringYupOptional(2000, maxLength2000Message),
    confidence_level: yup
      .number()
      .max(100, 'Number must be within the range of 0-100%')
  }),
  fields: [
    {
      type: 'text',
      label: 'Eye color',
      name: 'eye_color'
    },
    {
      type: 'text',
      label: 'Hair color/style',
      name: 'hair_color'
    },
    {
      type: 'select',
      label: 'Race',
      name: 'race',
      choices: [{ label: '', value: '' }].concat(
        convertHashToChoiceArray(races)
      )
    },
    {
      type: 'number',
      label: 'Age (approximate)',
      name: 'age'
    },
    {
      type: 'content',
      component: Divider
    },
    {
      type: 'custom',
      component: HeightField,
      name: 'height',
      measurementField: 'measurement_unit'
    },
    {
      type: 'custom',
      component: WeightField,
      name: 'weight',
      measurementField: 'measurement_unit'
    },
    {
      type: 'radio',
      label: 'Unit of measurement',
      name: 'measurement_unit',
      selectedValue: 'standard',
      choices: [
        { label: 'Standard', value: 'standard', checked: true },
        { label: 'Metric', value: 'metric' }
      ]
    },
    {
      type: 'content',
      component: Divider
    },
    {
      type: 'text',
      label: 'Language or accent',
      name: 'language_accent'
    },
    {
      type: 'text',
      label: 'Clothing',
      name: 'clothing'
    },
    {
      type: 'text',
      label: 'Tattoos or scars',
      name: 'tattoos_scars'
    },
    {
      type: 'text',
      label: 'Vehicle',
      name: 'vehicle',
      hint: 'Make model year/license plate number'
    },
    {
      type: 'content',
      component: Divider
    },
    {
      ...multilineField,
      max: 2000,
      label: 'Additional information',
      name: 'additional_information',
      hint: `Here's your opportunity to provide information that wasn't captured previously. For example: alias, other identifying characteristics, or location last seen.`
    },
    {
      type: 'content',
      component: Divider
    },
    {
      type: 'number',
      label: 'Confidence level',
      name: 'confidence_level',
      hint: '0-100% confidence that the fugitive seen is an HHS-OIG fugitive',
      min: 0,
      max: 100,
      size: 'small'
    }
  ]
}
